import styled from 'styled-components'
import { ReactComponent as ChevronDownIcon } from 'shared/assets/icons/chevron-down.svg'

export const Container = styled.div`
  position: fixed;
  width: 400px;
  z-index: 9999;
  top: 64px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
 
  padding: 12px 16px;
  background: ${({ theme }) => theme.color.base.c0};
  border-radius: 16px;
`

export const ChevronButton = styled.button`
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  width: 40px;
  height: 40px;
  border: none;
  background: ${({ theme }) => theme.color.base.c0};
  border-radius: 50%;
  cursor: pointer;
`

export const ChevronIcon = styled(ChevronDownIcon)<{ isExpanded: boolean }>`
  position: absolute;
  bottom: -10px;
  top: 40%;
  left: 50%;
  z-index: 1;
  width: 24px;
  height: 24px;
  transform: ${({ isExpanded }) => `translateX(-50%) rotate(${isExpanded ? 180 : 0}deg)`};
`

export const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  margin-top: 32px;
  margin-bottom: 32px;
  max-height: 400px;
  overflow-y: auto;
`

export const AutomationItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.color.base.c3};
`

export const SeeMetadataButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.color.brand_02};
  font-weight: 500;
  font-size: 14px;
`

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.base.c7};
  margin: 0;
  margin-bottom: 12px;
`

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`

export const StatusTitle = styled.h4`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.base.c7};
  margin: 0;
`

export const Status = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.base.c9};
  margin: 0;
`

export const MiniStatus = styled.span`
  font-size: 11px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.base.c7};
  margin: 0;
`

export const ControlButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  background: transparent;
  border: none;
`
